import axios from 'axios';

export function getUserScreenActivity(token, userId, screenId) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/getUserScreenActivity`,
        { userId, screenId },
        { headers: { Authorization: `${token}` } },
    );
}
